export default "__VITE_ASSET__CYITnLe8__"